module.exports = __webpack_public_path__ + "fonts/fa-solid-900.333bae2.woff";